export default "__VITE_ASSET__DO3y$AEo__"